import React from 'react'

/**
 * Flatten a React node to plain text. FAQ answers are authored as JSX so the
 * page can emphasise words; structured data needs the same copy as a string,
 * and deriving it here keeps one source of truth instead of a parallel set of
 * plain-text answers that can drift.
 */
export function reactText(node: React.ReactNode): string {
  if (node === null || node === undefined || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(reactText).join('')
  if (React.isValidElement(node)) return reactText((node.props as { children?: React.ReactNode }).children)
  return ''
}

/** Collapse the whitespace JSX authoring introduces at line breaks. */
export function flatten(node: React.ReactNode): string {
  return reactText(node).replace(/\s+/g, ' ').trim()
}
